import { Injectable } from '@angular/core';
import {GeneralServicesImplService} from '../../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../../services/api/servers';
import {urls} from '../../../../services/api/urls';
import {Observable} from 'rxjs';
import {ProjectConstants} from '../../../project-constants';
import { ProviderModel } from 'src/models/ProviderModel';

@Injectable({
  providedIn: 'root'
})

export class ConsuntivoUploadService extends GeneralServicesImplService {
  constructor(http: HttpClient) {
    super(http);
  }

  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.consuntivoVolumiController;
  baseUrl: string = servers.apiUrl + urls.consuntivoVolumiController;

  uploadConsumptive(file: FormData, numAnnoMese: number, providerCod: string, status: string): Observable<any> {
    const url = this.baseUrl + this.LINKS.UPLOAD_CONSUMPTIVE_VOLUME
                             + '/' + numAnnoMese.toString()
                             + '/' + providerCod
                             + '/' + status;
    const body =  file;
    const header = ProjectConstants.returnHeaderBlank();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

}
